var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import SvgIcon from './icons/SvgIcon';
const DropdownWithIcon = (_a) => {
    var { selected, children, isOpen, toggle, isDefaultSelected } = _a, attributes = __rest(_a, ["selected", "children", "isOpen", "toggle", "isDefaultSelected"]);
    return (<Dropdown isOpen={isOpen} group={false} toggle={toggle} {...attributes}>
        <DropdownToggle tag="button" className={classnames('btn', 'dropdown__toggle', {
            'dropdown__toggle--selected': !isDefaultSelected,
        })}>
            <span>{selected}</span>
            <SvgIcon className="dropdown__toggle-icon" kind="ArrowDown" size={14}/>
        </DropdownToggle>
        <DropdownMenu modifiers={{
            offset: {
                fn: (data) => (Object.assign(Object.assign({}, data), { styles: Object.assign(Object.assign({}, data.styles), { top: '15px' }) })),
            },
        }}>
            {children}
        </DropdownMenu>
    </Dropdown>);
};
export default DropdownWithIcon;
